define(function (require) {
    'use strict';

    var Marionette      = require('marionette');
    var ModalsFactory   = require('modals/factory');

    return Marionette.Behavior.extend({
        ui: {
            button: '.js-modal'
        },

        events: {
            'click @ui.button': 'Show'
        },

        initialize: function () {
            app.Vents.off('modal:showModal');
            app.Vents.on('modal:showModal', this.Show, this);
        },

        Show: function (e) {
            e.stopPropagation();
            e.preventDefault();

            var modalData = $(e.currentTarget).data();
            var path = $(e.currentTarget).data('modal');

            ModalsFactory.create(path, function (Modal) {
                app.regionModal.show(new Modal({
                    curElement: $(e.currentTarget),
                    modalData: modalData
                }));
            });
        },

        onShowModal: function(modal) {
            app.regionModal.show(modal);
        }
    });
});
